/*
Some Table props are used as "settings" and various children components need to
know about them (e.g., the row component need to know if the table is
`striped`). This context will provide those settings. The provider is set in
the Table component.
*/
import React from "react";
export const Context = /*#__PURE__*/React.createContext({});